import React from 'react';

import s from 'src/components/Clearfix/Clearfix.styles';

export const Clearfix = () => (
  <s.Clearfix />
);
